import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

/**
 * Live cycle count since clock-in, before PCM. Resets when the operator submits the ticket.
 */
export const getLaborScopeRawParts = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.laborTicketParts;
  }
);
